var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HereMaps',{attrs:{"name":"map-iot","latitude":"4.686699","longitude":"-74.0837187","zoom":"13","theme":_vm.mapTheme,"streetview":"true"}})}
var staticRenderFns = []

export { render, staticRenderFns }